import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { FormattedNumber } from 'react-intl'

import styles from './IndustrialResource.scss'


const IndustrialResource = (props) => {
    const className = classNames(
        props.className,
        styles.base,
        props.notEnough && styles.base__notEnough,
        props.small && styles.base__small,
        props.large && styles.base__large,
        props.custom && styles.base__custom,
        props.iconAtLeft && styles.base__iconAtLeft,
    )

    const tooltipProps = (props.popoverId) ? {
        'data-tip': true,
        'data-for': props.popoverId,
    } : null

    return (
        <span className={className} {...tooltipProps}>
            {props.iconAtLeft && <span className={styles.base_icon} />}
            <FormattedNumber value={props.value} />
            {!props.iconAtLeft && <span className={styles.base_icon} />}
        </span>
    )
}
IndustrialResource.propTypes = {
    className: PropTypes.string,
    value: PropTypes.number.isRequired,
    notEnough: PropTypes.bool,
    small: PropTypes.bool,
    large: PropTypes.bool,
    custom: PropTypes.bool,
    popoverId: PropTypes.string,
    iconAtLeft: PropTypes.bool,
}

export default IndustrialResource



// WEBPACK FOOTER //
// ./components/IndustrialResource/IndustrialResource.jsx